import { FC, useMemo } from 'react';
import { DpCarouselIARecommendation } from '@/components/blocks/DpCarouselIARecommendation';
import { usePageBlock } from '@/data/context/pageBlock';
import { CLICK_PRODUCT_VIEW_SOURCE } from '@/data/constants/clickProductView';

const useExtractPDPParams = () => {
	const pageBlock = usePageBlock();

	const partNumber = useMemo(() => pageBlock?.meta?.pageIdentifier, [pageBlock]);

	return partNumber
		? {
				partNumber,
		  }
		: null;
};

export const DpCarouselPDPIARecommendation: FC<{
	id: string;
	title?: string;
	type?: 'recommendation' | 'outfit';
	transform: unknown;
	filters: unknown;
}> = ({ id, title, type = 'recommendation', transform, filters }) => {
	const params = useExtractPDPParams();

	if (!params) {
		return null;
	}

	return (
		<DpCarouselIARecommendation
			id={id}
			type={type}
			title={title}
			params={params}
			transform={transform}
			filters={filters}
			highlightFirstProduct={type === 'outfit'}
			clickSource={
				type === 'outfit'
					? CLICK_PRODUCT_VIEW_SOURCE.PDP_RECOMMENDED_OUTFIT
					: CLICK_PRODUCT_VIEW_SOURCE.PDP_RECOMMENDED_SIMILAR
			}
		/>
	);
};
